import React, { useState, useContext } from "react";
import DateTimeNavigation from "./DateTimeNavigation";
import DateTimeCalendar from "./DateTimeCalendar";
import "../../../../../styles/global.css";
import TimePicker from "./TimePicker";
import { TranslationsContext } from "../../../../../utils/TranslationsContext";
import AccreditationButton from "../../../../AccreditationButton/AccreditationButton";

const DateTimePopup = ({
  selectedDate,
  setSelectedDate,
  hours,
  setHours,
  minutes,
  setMinutes,
  onChange,
  birthDate,
  registration_deadline,
}) => {
  const initialDate = selectedDate ? new Date(selectedDate) : new Date();
  const [currentYear, setCurrentYear] = useState(initialDate.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(initialDate.getMonth());
  const { t } = useContext(TranslationsContext);

  return (
    <div className="flex-direction-column gap-12 date-time-popup">
      <DateTimeNavigation
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        setCurrentMonth={setCurrentMonth}
        currentMonth={currentMonth}
        selectedDate={selectedDate}
      />

      <DateTimeCalendar
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        currentMonth={currentMonth}
        currentYear={currentYear}
      />
      {/* Vreme */}
      {!registration_deadline && (
        <TimePicker
          hours={hours}
          setHours={setHours}
          minutes={minutes}
          setMinutes={setMinutes}
        />
      )}

      {birthDate && (
        <AccreditationButton
          onClick={() => {
            onChange("");
          }}
          type="save"
          title={t("CLEAR")}
          className="modal-btn clear-btn"
        />
      )}
    </div>
  );
};

export default DateTimePopup;
